import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/imgs/alipay.png'
import _imports_1 from '../../assets/imgs/WingPay.png'


const _withScopeId = n => (_pushScopeId("data-v-1966c0f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recharge" }
const _hoisted_2 = { class: "Banks" }
const _hoisted_3 = { class: "ImgTips" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "alipayLogo",
  src: _imports_0
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "alipayLogo",
  src: _imports_1
}, null, -1))

import { ref, reactive, onMounted, getCurrentInstance, markRaw } from 'vue'
import type { FormInstance, FormRules } from 'element-plus'
import { ElMessageBox } from 'element-plus'
import PaginationHook from '@/hooks/pagination'
import Loading from '@/components/loading.vue'
import * as Api from '@/utils/api'
import OSS from '@/components/oss.vue'
import { formatDate } from '@/utils/format'
import { WingFrom } from '@/utils/wingFrom'
import { CircleCheck } from '@element-plus/icons-vue'

import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'recharge',
  setup(__props) {

const { t } = useI18n()

const userouter = useRouter()

let { proxy } = getCurrentInstance()

const FinanceAccountList = ref(null)
const isType = ref(1)
const isLoading = ref(false)
const ImgTipUrl = ref(null)

const OfflineRef = ref<FormInstance>()
const OfflineForm = reactive({
  amount: 0,
  currency_code: 'USD',
  account_no: null,
  account_name: null,
  memo: null,
  bank_id: null,
  operation_time: null,
  ImgUrlList: [],
})

const ThirdPartyRef = ref<FormInstance>()
const ThirdPartyForm = reactive({
  Amount: 0,
  WebsiteId: true,
  Memo: '',
  Channel: 1,
  NotifyUrl: location.href,
})

const validatePass = (rule: any, value: any, callback: any) => {
  if (value == 0) {
    callback(new Error(t('不能为0')))
  } else {
    callback()
  }
}

const ThirdPartyPass = (rule: any, value: any, callback: any) => {
  if (
    value < RechargeRate.value.MaxRechargeAmount &&
    value >= RechargeRate.value.MinRechargeAmount
  ) {
    callback()
  } else {
    callback(new Error(t('金额不满足条件')))
  }
}

const rules = reactive({
  amount: [{ required: true, validator: validatePass, trigger: 'change' }],
  bank_id: [{ required: true, message: t('不能为空'), trigger: 'change' }],
  operation_time: [
    { required: true, message: t('不能为空'), trigger: 'change' },
  ],
  ImgUrlList: [
    {
      type: 'array',
      required: true,
      message: t('不能为空'),
      trigger: 'change',
    },
  ],
})

const ThirdPartyRules = reactive({
  Amount: [{ required: true, validator: ThirdPartyPass, trigger: 'change' }],
})

const FAchange = () => {
  let FA = FinanceAccountList.value.find((res) => {
    return OfflineForm.bank_id == res.FinanceBankId
  })
  ImgTipUrl.value = FA.SampleImg || null
  OfflineForm.account_no = FA.AccountNo
  OfflineForm.account_name = FA.AccountName
}

const OfflineSubmit = () => {
  proxy.$refs['OfflineRef'].validate((valid: boolean) => {
    if (valid) {
      OfflineForm.operation_time = formatDate(
        OfflineForm.operation_time,
        'yyyy-MM-dd hh:mm:ss'
      )

      let body = Object.assign({ ImgUrlList: [] }, OfflineForm)
      body.ImgUrlList = body.ImgUrlList.map((item) => {
        return item.url
      })
      isLoading.value = true
      Api.Post('bank/api/BalanceAuditsByNew', body)
        .then((res) => {
          isLoading.value = false
          proxy.$refs['OfflineRef'].resetFields()
          let tips = t('提交成功!您的充值号为') + res.Request.SerialNumber
          ElMessageBox.confirm(tips, t('提示'), {
            dangerouslyUseHTMLString: true,
            confirmButtonText: t('我要购物'),
            cancelButtonText: t('继续充值'),
          }).then(() => {
            userouter.push('/')
          })
        })
        .catch((err) => {
          isLoading.value = false
        })
    }
  })
}

const ThirdPartySubmit = () => {
  proxy.$refs['ThirdPartyRef'].validate((valid: boolean) => {
    if (valid) {
      let params1 = {
        RechargeType: 'MPAY',
        PayType: 'ALIPAY',
      }

      let params2 = {
        RechargeType: 'Wing',
        PayType: '',
        IsApp: false,
      }

      let params3 = Object.assign(
        isType.value == 2 ? params1 : params2,
        ThirdPartyForm
      )
      isLoading.value = true
      Api.Post('bank/api/OtherRecharges/', params3)
        .then((res) => {
          isLoading.value = false
          proxy.$refs['ThirdPartyRef'].resetFields()
          sessionStorage.setItem(
            'RechargePayUrl',
            isType.value == 2
              ? res.PaymentParams
              : WingFrom(res, ThirdPartyForm.NotifyUrl)
          )
          window.open('https://www.loda.com.kh/wing_pay.html', '_blank')
          ElMessageBox.confirm(
            t('支付完成后,请根据您支付的情况点击下面按钮'),
            t('提示'),
            {
              cancelButtonText: t('支付遇到问题'),
              confirmButtonText: t('支付完成'),
              type: 'success',
              icon: markRaw(CircleCheck),
            }
          )
            .then(() => {})
            .catch(() => {})
        })
        .catch((err) => {
          isLoading.value = false
        })
    }
  })
}

const RechargeRate = ref(null)

const RechargeType = () => {
  switch (isType.value) {
    case 1:
      Api.Get('bank/api/BalanceAudits/', {}).then((res) => {
        FinanceAccountList.value = res.FinanceAccountList
      })
      break
    case 2:
    case 3:
      RechargeRate.value = null
      Api.Get('basic/api/RechargeRate', {
        WebsiteId: true,
        rechargetype: isType.value == 2 ? 'MPay' : 'Wing',
      }).then((res) => {
        RechargeRate.value = res
      })
      break
  }
}

onMounted(() => {
  RechargeType()
})

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      modelValue: isType.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isType).value = $event)),
      type: "border-card",
      onTabChange: RechargeType
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          name: 1,
          label: _ctx.$t('线下充值')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "OfflineRef",
              ref: OfflineRef,
              model: OfflineForm,
              rules: rules,
              "label-position": "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('汇入银行'),
                  prop: "bank_id"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(Loading, { type: "4" }, null, 512), [
                      [_vShow, !FinanceAccountList.value]
                    ]),
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_el_radio_group, {
                        modelValue: OfflineForm.bank_id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((OfflineForm.bank_id) = $event)),
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (FAchange()))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(FinanceAccountList.value, (FA, index) => {
                            return (_openBlock(), _createBlock(_component_el_radio, {
                              key: index,
                              label: FA.FinanceBankId
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(FA.BankName), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('充值金额'),
                  prop: "amount"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: OfflineForm.amount,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((OfflineForm.amount) = $event)),
                      precision: 2,
                      step: 1,
                      min: 0,
                      "value-on-clear": 0
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('充值时间'),
                  prop: "operation_time"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: OfflineForm.operation_time,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((OfflineForm.operation_time) = $event)),
                      type: "datetime",
                      clearable: _ctx.fasle
                    }, null, 8, ["modelValue", "clearable"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('充值证明'),
                  prop: "ImgUrlList"
                }, {
                  default: _withCtx(() => [
                    _createVNode(OSS, {
                      type: 2,
                      imgList: OfflineForm.ImgUrlList,
                      max: 1
                    }, null, 8, ["imgList"]),
                    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("请按照示例上传图片，图片不正确或者不清楚都会导致审核过慢或者审核不通过。")), 1),
                    _withDirectives(_createVNode(_component_el_image, {
                      class: "ImgTipUrl",
                      src: ImgTipUrl.value,
                      "preview-src-list": [ImgTipUrl.value],
                      lazy: ""
                    }, null, 8, ["src", "preview-src-list"]), [
                      [_vShow, ImgTipUrl.value]
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('备注'),
                  prop: "memo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      rows: 4,
                      type: "textarea",
                      modelValue: OfflineForm.memo,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((OfflineForm.memo) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "danger",
                      size: "large",
                      onClick: OfflineSubmit,
                      loading: isLoading.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('提交')), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_tab_pane, {
          name: 2,
          label: _ctx.$t('支付宝充值')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "ThirdPartyRef",
              ref: ThirdPartyRef,
              model: ThirdPartyForm,
              rules: ThirdPartyRules,
              "label-position": "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('充值金额'),
                  prop: "Amount"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: ThirdPartyForm.Amount,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ThirdPartyForm.Amount) = $event)),
                      precision: 2,
                      step: 1,
                      min: RechargeRate.value?.MinRechargeAmount || 0,
                      disabled: !RechargeRate.value,
                      "value-on-clear": 0
                    }, null, 8, ["modelValue", "min", "disabled"]),
                    _createElementVNode("label", null, "  " + _toDisplayString(_ctx.$t('币种')) + ": " + _toDisplayString(_ctx.$currency.A), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_Transition, { name: "el-fade-in" }, {
                  default: _withCtx(() => [
                    (RechargeRate.value)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          class: "RechargeRate"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", null, [
                              _createTextVNode(_toDisplayString(_ctx.$t('最小充值金额')) + ": ", 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$currency.B) + " " + _toDisplayString(RechargeRate.value.MinRechargeAmount.toFixed(2)), 1)
                            ]),
                            _createElementVNode("p", null, [
                              _createTextVNode(_toDisplayString(_ctx.$t('最大充值金额')) + ": ", 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$currency.B) + " " + _toDisplayString(RechargeRate.value.MaxRechargeAmount.toFixed(2)), 1)
                            ]),
                            _createElementVNode("p", null, [
                              _createTextVNode(_toDisplayString(_ctx.$t('手续费')) + ": ", 1),
                              _createElementVNode("span", null, _toDisplayString(RechargeRate.value.Rate), 1)
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "danger",
                      size: "large",
                      onClick: ThirdPartySubmit,
                      disabled: !RechargeRate.value,
                      loading: isLoading.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('提交')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_tab_pane, {
          name: 3,
          label: _ctx.$t('Wing充值')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "ThirdPartyRef",
              ref: ThirdPartyRef,
              model: ThirdPartyForm,
              rules: ThirdPartyRules,
              "label-position": "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('充值金额'),
                  prop: "Amount"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: ThirdPartyForm.Amount,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((ThirdPartyForm.Amount) = $event)),
                      precision: 2,
                      step: 1,
                      min: RechargeRate.value?.MinRechargeAmount || 0,
                      disabled: !RechargeRate.value,
                      "value-on-clear": 0
                    }, null, 8, ["modelValue", "min", "disabled"]),
                    _createElementVNode("label", null, "  " + _toDisplayString(_ctx.$t('币种')) + ": " + _toDisplayString(_ctx.$currency.A), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_Transition, { name: "el-fade-in" }, {
                  default: _withCtx(() => [
                    (RechargeRate.value)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          class: "RechargeRate"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", null, [
                              _createTextVNode(_toDisplayString(_ctx.$t('最小充值金额')) + ": ", 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$currency.B) + " " + _toDisplayString(RechargeRate.value.MinRechargeAmount.toFixed(2)), 1)
                            ]),
                            _createElementVNode("p", null, [
                              _createTextVNode(_toDisplayString(_ctx.$t('最大充值金额')) + ": ", 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$currency.B) + " " + _toDisplayString(RechargeRate.value.MaxRechargeAmount.toFixed(2)), 1)
                            ]),
                            _createElementVNode("p", null, [
                              _createTextVNode(_toDisplayString(_ctx.$t('手续费')) + ": ", 1),
                              _createElementVNode("span", null, _toDisplayString(RechargeRate.value.Rate), 1)
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "danger",
                      size: "large",
                      onClick: ThirdPartySubmit,
                      disabled: !RechargeRate.value,
                      loading: isLoading.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('提交')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})